// extracted by mini-css-extract-plugin
export default {"portfolioDis":"Portfolio_portfolioDis__VkqGI","portfolioDisImg":"Portfolio_portfolioDisImg__xiofq","portfolioHeading":"Portfolio_portfolioHeading__0ZjJw"};